import React, { useState } from "react";

import PropTypes from 'prop-types';
import { REVALIDATE_AND_SUBMIT } from "../../../../constants/actionButtons";
import { FEATURES } from "../../../../constants/features";
import { renderTernary } from "../../../../helpers/utils";
import BulkResubmitModal from "../../../../components/Modal/BulkResubmitModal/BulkResubmitModal";
import { InvoiceBulkResubmitStyles } from "./InvoiceBulkResubmit.styles";
import { Button } from "@livingdesign/react";
import { useSelector } from "react-redux";


/**
* This Modal enables user to select bulk resubmit for the current selection
*/
const InvoiceBulkResubmit = (props) => {
    const { bulkUpdateButtonOptions } = props;
    const [resubmitModalOpen, setResubmitModalOpen] = useState(false);
    const [bulkActionLoading, setBulkActionLoading] = useState(false);
    const classes = InvoiceBulkResubmitStyles()
    const isPreValidationOrg = useSelector((state) => state?.user?.prevalidationEnabled);


    const selectedRowsLength = bulkUpdateButtonOptions?.invoiceIds?.length;
    /**  Gets called when clicked on Resubmit button */
    const handleResubmitChange = (selectedId) => {
        setResubmitModalOpen(true)
    };
    return (
        <>
            {renderTernary(isPreValidationOrg,
                <div className={classes.resubmit}>
                    <Button
                        size="small"
                        variant="primary"
                        onClick={handleResubmitChange}
                        data-testid="bulk-resubmit-btn"
                        disabled={bulkUpdateButtonOptions?.disableButton || bulkActionLoading}
                    >
                        {REVALIDATE_AND_SUBMIT}
                    </Button>
                </div>, <></>)}
            <BulkResubmitModal
                open={resubmitModalOpen}
                handleModalOpen={setResubmitModalOpen}
                invoiceIds={bulkUpdateButtonOptions?.invoiceIds}
                filteredRowsData={bulkUpdateButtonOptions?.invoiceIds}
                bulkActionLoading={bulkActionLoading}
                setBulkActionLoading={setBulkActionLoading}
                selectedRowsLength={selectedRowsLength}
                reloadPage={bulkUpdateButtonOptions?.reloadPage}
            />
        </>
    )
}
export default InvoiceBulkResubmit;

InvoiceBulkResubmit.propTypes = {
    bulkUpdateButtonOptions: PropTypes.object
};

InvoiceBulkResubmit.defaultProps = {
    bulkUpdateButtonOptions: {}
}